import { SearchNames } from 'data/search';


export default function renderTypeCell(value) {
  return SearchNames[value];
}
